function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoUniHorizontalVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 269,
    height: 40,
    viewBox: "0 0 269 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "_ngcontent-serverApp-c1": ""
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "letter-green",
    points: "60.6,5.6 60.6,30.5 40.4,5.6 35.1,5.6 35.1,39.6 40.6,39.6 40.6,14.7 60.8,39.6 66.4,39.6    66.4,5.6  ",
    style: {
      fill: "#004A35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "letter-green",
    height: 34,
    style: {
      fill: "#004A35"
    },
    width: 7.1,
    x: 72.7,
    y: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.9,24.9L254,1l-0.1-0.2c0,0,0,0,0,0C253.5,0.3,253,0,252.4,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0   h-17.5h0c0,0-0.1,0-0.1,0h0c-0.1,0-0.1,0-0.2,0h0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.4,0.1-0.7,0.4-1.1,0.8   l-22.3,23.9c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.5,0.4,0.8,0.8,0.9h0c0,0,10.6,0,10.6,0   c0.2,0,0.3,0.1,0.3,0.3c0,0.1,0,0.1-0.1,0.2v0c0,0,0,0,0,0l-10.7,11.4c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.2,0.3   c0,0.1,0,0.2,0,0.2c0,0.2,0.1,0.4,0.3,0.6c0.1,0.1,0.3,0.1,0.5,0.2c0,0,0.1,0,0.1,0h7.2h0c0.4,0,0.9-0.2,1.2-0.5c0,0,0,0,0,0   L231.7,27c0.1-0.1,0.1-0.1,0.1-0.2c0-0.2-0.1-0.3-0.3-0.3c0,0-6.1,0-6.1,0c-0.2,0-0.3-0.2-0.3-0.3c0-0.1,0-0.1,0.1-0.2v0l11.9-12.7   c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.4-0.3,0.6-0.3c0.3,0,0.5,0.1,0.7,0.4c0,0,6.7,11.6,6.7,11.6l0.7,1.2c0,0,0,0,0,0l0,0.1h0   c0,0,0,0.1,0,0.1c0,0.2-0.1,0.3-0.3,0.3c0,0-6.2,0-6.2,0c-0.2,0-0.4,0.2-0.4,0.4c0,0.1,0,0.2,0.1,0.3l6.7,11.6l0,0.1   c0.3,0.5,0.8,0.8,1.3,0.8h0.3h13.8h0c0.2,0,0.3,0,0.5-0.1c0.4-0.2,0.6-0.5,0.6-0.9c0-0.1,0-0.3-0.1-0.4l-0.1-0.2l-6.5-11.2   c0,0,0-0.1,0-0.1h0l0,0c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0.1,0h11h0h0h0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0   c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1   c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1C268.1,25.6,268.1,25.3,267.9,24.9 M246.4,12.2L246.4,12.2C246.4,12.2,246.4,12.2,246.4,12.2   l-16.9,0c0,0,0,0,0,0c-0.2,0-0.3-0.2-0.3-0.3c0-0.1,0-0.2,0.1-0.2l0,0L239.3,1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.5-0.2   c0,0,0,0,0,0c0,0,0,0,0.1,0c0.2,0,0.5,0.2,0.6,0.4c0,0,6.1,10.6,6.1,10.6c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.2   C246.8,12,246.6,12.2,246.4,12.2",
    style: {
      fill: "#B9A557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.4,5.6 152.7,5.6 146.4,39.6 166.9,39.6 167.9,33.8 156.7,33.8 158.4,24.7 167.5,24.7    168.6,18.9 159.5,18.9 160.9,11.4 170.3,11.4  ",
    style: {
      fill: "#B9A557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,5.6h-11.9l-6.4,34h11.6c11.2,0,20.8-7.5,20.8-19.7C203.2,11.4,198.3,5.6,189.1,5.6    M183.6,33.8h-2.4l4.2-22.4h2.5c3.7,0,5.9,4.2,5.9,8.6C193.7,29,187.9,33.8,183.6,33.8",
    style: {
      fill: "#B9A557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,33.8c-3.7,0-5.9-4.2-5.9-8.6c0-9,5.9-13.8,10.1-13.8h11.5l1.1-5.8h-11.4   c-11.2,0-20.8,7.5-20.8,19.7c0,8.4,4.9,14.3,14.1,14.3H112l1.1-5.8L101.4,33.8z",
    style: {
      fill: "#B9A557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,24.5c3.2-1.6,7.2-4.3,7.2-10.2c0-3.6-2.4-8.6-9.6-8.6h-13.7l-6.4,34h9.2l2.4-12.9h2.6   l3.5,12.9h10.1L138.3,24.5z M131.3,20.9h-2.8l1.9-9.6h2.4c2,0,3.6,2,3.6,4C136.4,18.5,133.8,20.9,131.3,20.9",
    style: {
      fill: "#B9A557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "letter-green",
    d: "M21.8,5.6v18.6c-0.2,7.6-1.6,12-7.3,12h-0.1c-5.7,0-7.2-4.4-7.3-12V5.6H0v20.8   c0,7.4,2.7,11.8,9,13.2c0,0,1.8,0.4,4.9,0.4h1c3.1,0,4.6-0.4,4.6-0.4c6.6-1.3,9.3-5.9,9.3-13.2V5.6H21.8z",
    style: {
      fill: "#004A35"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUniHorizontalVerde);
export default __webpack_public_path__ + "static/media/logo_uni_horizontal_verde.2842bfb7f681ae23393b92c311553813.svg";
export { ForwardRef as ReactComponent };